import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectCpId } from '@app/auth/store/auth.selectors';
import { AppService } from './app.service';
import { loadAllLocales, loadAllLocalesFailure, loadAllLocalesSuccess } from './app.actions';

@Injectable()
export class AppEffects {
  loadAllLocales$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadAllLocales),
      concatLatestFrom(() => this.store.select(selectCpId)),
      mergeMap(([, cpId]) => {
        if (!cpId) {
          return of(loadAllLocalesFailure({ error: 'Customer not selected' }));
        }
        return this.appService.getAllLocales(cpId).pipe(
          map((locales) => locales.map(i => ({locale_code: i.locale_code, display_value: i.value || i.display_value, locale_id: i.locale_id}))),
          map((locales) => loadAllLocalesSuccess({ locales })),
          catchError((error) => of(loadAllLocalesFailure({ error })))
        );
      })
    )
  );

  constructor(
    private actions$: Actions,
    private appService: AppService,
    private store: Store
  ) {}
} 